"use client";

import * as React from "react";
import { MagicBackButton } from "./magic-back-button";
import { ArrowLeft, Home, ArrowLeftCircle, Undo } from "lucide-react";

export function MagicBackButtonCustomContentDemo() {
  return (
    <div className="flex flex-wrap gap-4">
      <div className="space-y-2">
        <p className="text-sm font-medium">Default</p>
        <MagicBackButton />
      </div>

      <div className="space-y-2">
        <p className="text-sm font-medium">Custom Icon</p>
        <MagicBackButton>
          <ArrowLeft className="h-4 w-4" />
        </MagicBackButton>
      </div>

      <div className="space-y-2">
        <p className="text-sm font-medium">Home Icon</p>
        <MagicBackButton>
          <Home className="h-4 w-4" />
        </MagicBackButton>
      </div>

      <div className="space-y-2">
        <p className="text-sm font-medium">Circle Icon</p>
        <MagicBackButton>
          <ArrowLeftCircle className="h-4 w-4" />
        </MagicBackButton>
      </div>

      <div className="space-y-2">
        <p className="text-sm font-medium">Undo Icon</p>
        <MagicBackButton>
          <Undo className="h-4 w-4" />
        </MagicBackButton>
      </div>

      <div className="space-y-2">
        <p className="text-sm font-medium">Text Button</p>
        <MagicBackButton className="h-9 px-4 rounded-md">
          <span className="flex items-center">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Go Back
          </span>
        </MagicBackButton>
      </div>
    </div>
  );
}
